var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "编辑品牌",
            top: "100px",
            width: "60vw",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "150px", model: _vm.pram } },
            [
              _c("el-form-item", { attrs: { label: "品牌名称：" } }, [
                _c("div", [_vm._v(_vm._s(_vm.pram.brandName))]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "品牌logo：", prop: "brandLogo" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "upLoadPicBox",
                          on: {
                            click: function ($event) {
                              return _vm.modalPicTap("1", "brandLogo")
                            },
                          },
                        },
                        [
                          _vm.pram.brandLogo
                            ? _c("div", { staticClass: "pictrue" }, [
                                _c("img", {
                                  attrs: { src: _vm.pram.brandLogo },
                                }),
                              ])
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.pram.styleImg
                        ? _c("i", {
                            staticClass: "el-icon-delete",
                            staticStyle: { color: "red", "font-size": "16px" },
                            on: {
                              click: function ($event) {
                                return _vm.removeImg("brandLogo")
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "启用状态：", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "跳转链接ID：",
                    prop: "id",
                    rules: [
                      {
                        required: true,
                        message: "请填写跳转链接ID",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.pram.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "id", $$v)
                      },
                      expression: "pram.id",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "花喜ID：",
                    prop: "hxBrandCode",
                    rules: [{ required: true, message: "请填写花喜ID" }],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.pram.hxBrandCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "hxBrandCode", $$v)
                      },
                      expression: "pram.hxBrandCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "来一票ID：",
                    prop: "lypBrandCode",
                    rules: [{ required: true, message: "请填写来一票ID" }],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.pram.lypBrandCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "lypBrandCode", $$v)
                      },
                      expression: "pram.lypBrandCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "使用渠道：",
                    prop: "channel",
                    rules: [
                      {
                        required: true,
                        message: "请选择使用渠道",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.pram.channel,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "channel", $$v)
                        },
                        expression: "pram.channel",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "花喜", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "来一票", value: 2 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "最低毛利率：", prop: "grossMargin" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      min: 0,
                      max: 100,
                      step: 0.01,
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.pram.grossMargin,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "grossMargin", $$v)
                      },
                      expression: "pram.grossMargin",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "line-height": "20px",
                        color: "#999",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t            请输入可以在小程序商品展示的最低毛利率"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\t            如设置最低毛利率为20%，那么低于20%毛利率的商品将不展示"
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          "渠道为来一票时：麦当劳、肯德基。暂不支持毛利率限制。"
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "调价方式：", prop: "priceAdjustType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.priceAdjustType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "priceAdjustType", $$v)
                        },
                        expression: "pram.priceAdjustType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("不调价"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("按比例调价"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.pram.priceAdjustType === 0
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "10px",
                            color: "#909399",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("以原价展示售价")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.pram.priceAdjustType === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "调价比例：",
                                prop: "priceAdjustRatio",
                                rules: [
                                  {
                                    required: true,
                                    message: "请输入调价比例",
                                    trigger: "blur",
                                  },
                                  {
                                    validator: _vm.validatePriceAdjustRatio,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入调价比例",
                                },
                                model: {
                                  value: _vm.pram.priceAdjustRatio,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pram, "priceAdjustRatio", $$v)
                                  },
                                  expression: "pram.priceAdjustRatio",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-top": "10px",
                                    color: "#909399",
                                    "font-size": "12px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "来一票售价调价，请输入-100到100之间的数"
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "最大毛利率开关：",
                    prop: "maxGrossMarginEnabled",
                  },
                },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.pram.maxGrossMarginEnabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "maxGrossMarginEnabled", $$v)
                      },
                      expression: "pram.maxGrossMarginEnabled",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.maxGrossMarginEnabled === 1
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "最大毛利率：",
                        prop: "maxGrossMargin",
                        rules: [
                          {
                            required: true,
                            message: "请输入最大毛利率",
                            trigger: ["blur", "change"],
                          },
                          {
                            validator: _vm.validateMaxGrossMargin,
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          min: 0.01,
                          max: 100,
                          step: 0.01,
                          precision: 2,
                          placeholder: "请输入",
                        },
                        model: {
                          value: _vm.pram.maxGrossMargin,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "maxGrossMargin", $$v)
                          },
                          expression: "pram.maxGrossMargin",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "line-height": "20px",
                            color: "#999",
                            "margin-top": "10px",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t            商品毛利率超过设置值时，将按最大毛利率重新计算售价"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t\t例如设置最大毛利率为 20%，毛利率超过 20% 的商品将按 20% 毛利率重新计算售价\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "顶部提示：" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: 20, placeholder: "请输入" },
                    model: {
                      value: _vm.pram.titleDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "titleDesc", $$v)
                      },
                      expression: "pram.titleDesc",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { color: "#999" } }, [
                    _vm._v("最多输入20字！"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "温馨提示：" } },
                [
                  _c("Tinymce", {
                    staticClass: "editer",
                    attrs: { height: 300, sourceType: "goods" },
                    model: {
                      value: _vm.pram.tips,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "tips", $$v)
                      },
                      expression: "pram.tips",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }